import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/interfaces/api-response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FolderService {

    private apiURL = environment.appApiUrl + "folders";

    constructor(private http: HttpClient) { }

    getFolders(): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.apiURL);
    }

    getDefaultFolders(userSymfonyID: number): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.apiURL + '/default/' + userSymfonyID);
    }

    updateFolderName(folderID: number, newName : string): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.apiURL + '/update/' + folderID, newName);
    }

    deleteFolder(folderID: number): Observable<ApiResponse> {
        return this.http.delete<ApiResponse>(this.apiURL + '/delete/' + folderID);
    }

    addFolder(parentFolderID: number, folderChildName: string): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.apiURL + '/addChild/' + parentFolderID , folderChildName);
    }
}

